import {
  TelemetryEventLabel,
  LatencyReporterOptions,
} from '@packages/systems/designer-telemetry';
import {getCanvasAppParentOrigin} from '@packages/utilities/canvas-origin';

/** Reports latency measurement completion from Canvas App to Designer App via postMessage.
 *  Used to track performance metrics between cross-origin iframe interactions. */
export const reportLatencyFinished = (
  label: TelemetryEventLabel,
  options: LatencyReporterOptions = {},
  additionalEventProperties: Record<string, any> = {}
) => {
  const message = {
    method: 'reportLatencyFinished',
    name: label,
    data: additionalEventProperties,
    options,
  };
  const designerAppOrigin = getCanvasAppParentOrigin(window);

  if (designerAppOrigin) {
    window.parent.postMessage(message, designerAppOrigin);
  }
};
